import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../js/coreRuntime.mjs';
import { AbstractSet2mw1ev10zm1bz as AbstractSet } from './AbstractSet.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../hacks.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from './_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMap$keys$1$iterator$1Class;
function AbstractMap$keys$1$iterator$1() {
  if (AbstractMap$keys$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.ej_1 = $entryIterator;
      }
      q1() {
        return this.ej_1.q1();
      }
      r1() {
        return this.ej_1.r1().m3();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1$iterator$1Class = $;
  }
  return AbstractMap$keys$1$iterator$1Class;
}
var AbstractMap$values$1$iterator$1Class;
function AbstractMap$values$1$iterator$1() {
  if (AbstractMap$values$1$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.fj_1 = $entryIterator;
      }
      q1() {
        return this.fj_1.q1();
      }
      r1() {
        return this.fj_1.r1().n3();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1$iterator$1Class = $;
  }
  return AbstractMap$values$1$iterator$1Class;
}
function toString_0($this, entry) {
  return toString_1($this, entry.m3()) + '=' + toString_1($this, entry.n3());
}
function toString_1($this, o) {
  return o === $this ? '(this Map)' : toString(o);
}
function implFindEntry($this, key) {
  var tmp0 = $this.l3();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (equals(element.m3(), key)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractMap$keys$1Class;
function AbstractMap$keys$1() {
  if (AbstractMap$keys$1Class === VOID) {
    class $ extends AbstractSet() {
      constructor(this$0) {
        return new.target.hj(this$0);
      }
      static hj(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.gj_1 = this$0;
        return this.ij($box);
      }
      i9(element) {
        return this.gj_1.s4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.i9(element);
      }
      p1() {
        var entryIterator = this.gj_1.l3().p1();
        return new (AbstractMap$keys$1$iterator$1())(entryIterator);
      }
      q2() {
        return this.gj_1.q2();
      }
    }
    initMetadataForClass($);
    AbstractMap$keys$1Class = $;
  }
  return AbstractMap$keys$1Class;
}
var AbstractMap$values$1Class;
function AbstractMap$values$1() {
  if (AbstractMap$values$1Class === VOID) {
    class $ extends AbstractCollection() {
      constructor(this$0) {
        return new.target.kj(this$0);
      }
      static kj(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.jj_1 = this$0;
        return this.n6($box);
      }
      r9(element) {
        return this.jj_1.t4(element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.r9(element);
      }
      p1() {
        var entryIterator = this.jj_1.l3().p1();
        return new (AbstractMap$values$1$iterator$1())(entryIterator);
      }
      q2() {
        return this.jj_1.q2();
      }
    }
    initMetadataForClass($);
    AbstractMap$values$1Class = $;
  }
  return AbstractMap$values$1Class;
}
var AbstractMapClass;
function AbstractMap() {
  if (AbstractMapClass === VOID) {
    class $ {
      static t7() {
        var $this = createThis(this);
        $this.r7_1 = null;
        $this.s7_1 = null;
        return $this;
      }
      s4(key) {
        return !(implFindEntry(this, key) == null);
      }
      t4(value) {
        var tmp0 = this.l3();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.n1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (equals(element.n3(), value)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      a8(entry) {
        if (!(!(entry == null) ? isInterface(entry, Entry()) : false))
          return false;
        var key = entry.m3();
        var value = entry.n3();
        // Inline function 'kotlin.collections.get' call
        var ourValue = (isInterface(this, KtMap()) ? this : THROW_CCE()).u4(key);
        if (!equals(value, ourValue)) {
          return false;
        }
        var tmp;
        if (ourValue == null) {
          // Inline function 'kotlin.collections.containsKey' call
          tmp = !(isInterface(this, KtMap()) ? this : THROW_CCE()).s4(key);
        } else {
          tmp = false;
        }
        if (tmp) {
          return false;
        }
        return true;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtMap()) : false))
          return false;
        if (!(this.q2() === other.q2()))
          return false;
        var tmp0 = other.l3();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.n1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (!this.a8(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      u4(key) {
        var tmp0_safe_receiver = implFindEntry(this, key);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n3();
      }
      hashCode() {
        return hashCode(this.l3());
      }
      n1() {
        return this.q2() === 0;
      }
      q2() {
        return this.l3().q2();
      }
      v4() {
        if (this.r7_1 == null) {
          var tmp = this;
          tmp.r7_1 = AbstractMap$keys$1().hj(this);
        }
        return ensureNotNull(this.r7_1);
      }
      toString() {
        var tmp = this.l3();
        return joinToString(tmp, ', ', '{', '}', VOID, VOID, (it) => toString_0(this, it));
      }
      w4() {
        if (this.s7_1 == null) {
          var tmp = this;
          tmp.s7_1 = AbstractMap$values$1().kj(this);
        }
        return ensureNotNull(this.s7_1);
      }
    }
    initMetadataForClass($, 'AbstractMap', VOID, VOID, [KtMap()]);
    AbstractMapClass = $;
  }
  return AbstractMapClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AbstractMap as AbstractMap3sqd8xvg0030s,
};
//endregion

//# sourceMappingURL=AbstractMap.mjs.map
